import SidebarLayout from "components/Layout/Layout";
import UserAccountList from "pages/Dasboard/MainDashBoard/component/UserAccountList";
import { Modal } from 'antd';
import { useState } from "react";
import CreateAccountModalContent, { AccountUserData } from "pages/Dasboard/MainDashBoard/component/CreateUserModal";
import { ArrowsLeftRightIcon, CardsThreeIcon, UsersIcon } from "@phosphor-icons/react";
import StatsCard from "components/BasicStatsCard";
import { useData } from "components/provider/data";

const UserManagementMainPage = () => {
    // Modal for create new user
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfirmLoading, setModalConfirmLoading] = useState(false);
    const { total_balance, total_trade, tradeHistoryChartData, totalAccounts, activeUsers } = useData();
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleCreateNewUser = async ({ userData }: {
        userData: AccountUserData
    }) => {
        setModalConfirmLoading(true);
    };


    const handleCancel = () => {
        console.log('Clicked cancel button');
        setIsModalOpen(false);
    };

    return (
        <SidebarLayout
            title={
                (
                    <h4 className="text-2xl font-bold !m-0 py-4">
                        Users Management Dashboard
                    </h4>
                )
            }
        >
            <Modal
                title="Tạo tài khoản người dùng mới"
                style={{ top: 20 }}
                open={isModalOpen}
                confirmLoading={modalConfirmLoading}
                onCancel={handleCancel}
                width={600}
                height={500}
                footer={null}
            >
                <CreateAccountModalContent returnData={(data) => {
                    handleCreateNewUser({
                        userData: data
                    });
                    setIsModalOpen(false);
                }} />
            </Modal>
            <div className="space-y-6">
                <div className="flex items-center justify-between">
                    <div>
                        <h2 className="text-2xl font-bold">Quản lý người dùng</h2>
                        <p className="mt-1">Quản lý thông tin và tài khoản người dùng</p>
                    </div>
                    <button
                        onClick={showModal}
                        className="px-4 py-2 !text-white bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-colors flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-plus mr-2">
                            <path d="M5 12h14"></path>
                            <path d="M12 5v14"></path>
                        </svg>
                        Thêm người dùng
                    </button>
                </div>
                <div className="w-full grid grid-cols-4 gap-6" >
                    <StatsCard
                        title="Tổng số người dùng"
                        icons={<UsersIcon className="!text-white" size={24} />}
                        value={activeUsers}
                    />
                    <StatsCard
                        title="Người dùng hoạt động"
                        icons={<UsersIcon className="!text-white"  size={24} />}
                        value={activeUsers}
                    />
                    <StatsCard
                        title="Tổng số tài khoản"
                        icons={<CardsThreeIcon className="!text-white"  size={24} />}
                        value={totalAccounts}
                    />
                    <StatsCard
                        title="Tổng số giao dịch"
                        icons={<ArrowsLeftRightIcon className="!text-white" size={24} />}
                        value={total_trade}
                    />
                </div>
                <UserAccountList />
            </div>
        </SidebarLayout>
    );
}

export default UserManagementMainPage;
